// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Properties from "../../Properties";
import type { ImageThumbnailPropsType, ImageThumbnailStatesType } from "../types/UserFormType";
import { getImageForEnrolment, deleteEnrolment } from "../../global/actions/databaseActions";
import { getInit } from "../../global/types/constants";
import LoadingProgress from "../../global/components/LoadingProgress";
import { buttonStyles } from "../../global/components/StyledButtons";

import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";

class ImageThumbnail extends Component<ImageThumbnailPropsType, ImageThumbnailStatesType> {
  constructor(props: ImageThumbnailPropsType) {
    super(props);
    this.state = {
      isDeleted: false
    };
  }

  deletePhoto = () => {
    this.setState({ isDeleted: true });
    this.props.actions.deleteEnrolment(this.props.db.conference.id, this.props.enrolment_uid);
  }

  render(): React$Element<*> | null {
    const color = this.props.classes.shineIcon;
    if (this.state.isDeleted) {
      return (
        <div className="thumbnail-wrapper">
          <LoadingProgress size={96} style={{ width: "96px", height: "96px" }} />
        </div>
      );
    }
    else {
      return (
        <div className="thumbnail-wrapper">
          <img src={this.props.img} className="thumbnail-img" />
          <CloseIcon className={"close-btn " + color} onClick={this.deletePhoto} />
        </div>
      );
    }
  }
}

function mapStateToProps(state, ownProps) {
  return { db: state.forensic.db };
};

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getImageForEnrolment, deleteEnrolment }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(buttonStyles)(ImageThumbnail));


// WEBPACK FOOTER //
// ./src/conference/component/ImageThumbnail.js